//----------------------
// <auto-generated>
//     Split from WebApiController.ts
//     Regenerate with: node scripts/splitWebApiController.js
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming


import { PosClientBase, PosClientConfig, throwException } from './base';
import type { AccessControlProvider, CurrencyConversionOverride, CurrencyConversionOverrideRequest, DeliveryOverride, EntitiesWithSummaryOfPurchaseOrder, EntitiesWithSummaryOfPurchaseOrderTicketGroup, EntitySearchResultOfEntitiesWithSummaryOfPurchaseOrderTicketGroup, FileResponse, MonthContainingPurchaseOrdersResult, MultiCurrencyAggregationRequestOfPurchaseOrderSearchRequestV2AndPurchaseOrderFilterQueryV2, PosUiActionResult, PosUiActionResultWithDataOfIEnumerableOfNullableLong, ProblemDetails, PurchaseEventOverride, PurchaseOrder, PurchaseOrderAggregationResponse, PurchaseOrderAggregationSummary, PurchaseOrderDetails, PurchaseOrderDetailsInput, PurchaseOrderExportRequest, PurchaseOrderFilterQueryV2, PurchaseOrderQuery, PurchaseOrderQueryV2, PurchaseOrderSearchRequestV2, PurchaseOrderTicketGroup, PurchasePaymentMethod, PurchaseVendor, PurchaseVendorAccount, PurchaseVendorAccountDetails, PurchasingIdInUseResultType, SaleCancellationReason, SecurePurchaseOrdersSearchMappedResult, TimePeriodContainingPurchaseOrderResult, TimePeriodType, ValueTupleOfISetOfIntegerAndISetOfGuid, ValueTupleOfISetOfLongAndPosFieldOfNullableQualityControlState, ValueTupleOfLongAndDecimal, ValueTupleOfNullableIntegerAndNullableIntegerAndNullableGuidAndBoolean } from './types';


export interface IPurchaseClient {

    getPurchaseOrderByPurchaseOrderId(purchaseOrderId: number | undefined, getCatalog: boolean | undefined): Promise<PurchaseOrderDetails>;

    getPurchaseOrdersByVendorOrderId(orderId: string | undefined): Promise<PurchaseOrderDetails[]>;

    getPurchaseOrders(query: PurchaseOrderQuery, useReadonlyDB: boolean | undefined): Promise<EntitiesWithSummaryOfPurchaseOrder>;

    /**
     * This use the exact same backend as GetPurchaseOrders, but it is used by Advance Search
    The split up allows proper instrumentation and monitoring of the two different use cases
    This endpoint can later be replaced with a different backend
     * @param useReadonlyDB (optional) 
     */
    searchPurchaseOrders(query: PurchaseOrderQuery, useReadonlyDB: boolean | undefined): Promise<EntitiesWithSummaryOfPurchaseOrder>;

    /**
     * Advanced search V2 with OpenSearch backend to get paginated results
     */
    searchPurchaseOrdersV2(query: PurchaseOrderQueryV2): Promise<EntitySearchResultOfEntitiesWithSummaryOfPurchaseOrderTicketGroup>;

    /**
     * Advanced search V2 with OpenSearch backend to result summary
     */
    searchPurchaseOrdersV2Summary(query: PurchaseOrderQueryV2): Promise<PurchaseOrderTicketGroup>;

    getPurchaseOrdersWithTicketGroups(query: PurchaseOrderQuery): Promise<EntitiesWithSummaryOfPurchaseOrderTicketGroup>;

    getTicketGroupsForEvents(query: PurchaseOrderQuery): Promise<{ [key: string]: EntitiesWithSummaryOfPurchaseOrderTicketGroup; }>;

    getAccessibleVendors(getDeliveryOverride: boolean | undefined, getVendorAccountsCount: boolean | undefined): Promise<PurchaseVendor[]>;

    getAccessibleAccessControlProviders(): Promise<AccessControlProvider[]>;

    getAccessibleVendorAccounts(input: ValueTupleOfISetOfIntegerAndISetOfGuid, searchText: string | null | undefined, take: number | null | undefined, skip: number | null | undefined): Promise<PurchaseVendorAccount[]>;

    getVendorAccountDetails(purchaseOrderVendorAccountId: string | undefined): Promise<PurchaseVendorAccountDetails>;

    getPurchaseOrderIdsUsingOrderId(orderId: string | undefined): Promise<number[]>;

    getIsPurchasingIdsInUse(orderId: string | undefined, purchaseOrderVendorId: number | null | undefined): Promise<PurchasingIdInUseResultType>;

    getMonthsContainerPurchaseOrders(query: PurchaseOrderQuery): Promise<MonthContainingPurchaseOrdersResult[]>;

    getTimePeriodContainerPurchaseOrders(query: PurchaseOrderQuery, timePeriodType: TimePeriodType | undefined): Promise<TimePeriodContainingPurchaseOrderResult[]>;

    insertPurchaseOrder(input: PurchaseOrderDetailsInput, isManual: boolean | undefined): Promise<PosUiActionResult>;

    addTicketGroupsToPurchaseOrder(input: PurchaseOrderDetailsInput, isManual: boolean | undefined): Promise<PosUiActionResult>;

    insertPurchaseOrders(input: PurchaseOrderDetailsInput[], isManual: boolean | undefined): Promise<PosUiActionResultWithDataOfIEnumerableOfNullableLong>;

    downloadPurchaseFileTemplate(includeEventIdFields: boolean | undefined): Promise<FileResponse>;

    /**
     * @param purchaseOrderId Used for route parsing so that action argument is parsed for consignee impersonation
     */
    updatePurchaseOrderByPurchaseOrderId(purchaseOrderId: number, input: PurchaseOrderDetailsInput): Promise<PosUiActionResult>;

    updatePurchasesQualityControlState(inputs: ValueTupleOfISetOfLongAndPosFieldOfNullableQualityControlState): Promise<boolean>;

    updatePurchaseOrderConversionRate(inputs: ValueTupleOfLongAndDecimal): Promise<boolean>;

    getVendor(vendorId: number | undefined): Promise<PurchaseVendor>;

    mergeVendor(vendor: PurchaseVendor): Promise<number | null>;

    deleteVendor(vendorId: number | undefined): Promise<boolean>;

    mergeVendorAccount(vendorAccount: PurchaseVendorAccountDetails): Promise<string | null>;

    deleteVendorAccount(vendorAccountId: string | undefined): Promise<boolean>;

    getAllCurrencyConversionOverride(): Promise<CurrencyConversionOverride[]>;

    insertCurrencyConversionOverride(conversionOverrideRequest: CurrencyConversionOverrideRequest): Promise<number | null>;

    updateCurrencyConversionOverride(conversionOverrideRequest: CurrencyConversionOverrideRequest): Promise<boolean>;

    deleteCurrencyConversionOverride(currencyConversionOverrideId: number | undefined): Promise<boolean>;

    getAccessiblePurchasePaymentMethods(): Promise<PurchasePaymentMethod[]>;

    getPurchasePaymentMethodsByName(paymentMethodName: string | undefined): Promise<PurchasePaymentMethod[]>;

    insertPurchasePaymentMethod(input: PurchasePaymentMethod): Promise<number>;

    updatePurchasePaymentMethod(input: PurchasePaymentMethod): Promise<boolean>;

    deletePurchasePaymentMethod(purchasePaymentMethodId: number): Promise<boolean>;

    cancelPurchaseOrder(purchaseOrderId: number | undefined, rejectSale: boolean | null | undefined, saleCancellationReason: SaleCancellationReason | null | undefined): Promise<boolean>;

    voidPurchaseOrder(purchaseOrderId: number | undefined): Promise<boolean>;

    restorePurchaseOrder(purchaseOrderId: number | undefined): Promise<boolean>;

    getDeliveryOverrideForNewTicketGroup(input: ValueTupleOfNullableIntegerAndNullableIntegerAndNullableGuidAndBoolean): Promise<DeliveryOverride | null>;

    mergePurchaseEventOverrides(purchaseEventOverrides: PurchaseEventOverride[], viagogoEventId: number | undefined): Promise<boolean>;

    getPurchaseEventOverrides(viagogoEventId: number | undefined): Promise<PurchaseEventOverride[]>;

    exportPurchases(request: PurchaseOrderExportRequest, selectedTicketGroupsOnly: boolean | undefined): Promise<FileResponse>;

    downloadMergedUserDocumentsPdf(ticketGroupId: number | undefined): Promise<FileResponse>;
}

export class PurchaseClient extends PosClientBase implements IPurchaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: PosClientConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getPurchaseOrderByPurchaseOrderId(purchaseOrderId: number | undefined, getCatalog: boolean | undefined, signal?: AbortSignal | undefined): Promise<PurchaseOrderDetails> {
        let url_ = this.baseUrl + "/api/Purchase/GetPurchaseOrderByPurchaseOrderId?";
        if (purchaseOrderId === null)
            throw new Error("The parameter 'purchaseOrderId' cannot be null.");
        else if (purchaseOrderId !== undefined)
            url_ += "purchaseOrderId=" + encodeURIComponent("" + purchaseOrderId) + "&";
        if (getCatalog === null)
            throw new Error("The parameter 'getCatalog' cannot be null.");
        else if (getCatalog !== undefined)
            url_ += "getCatalog=" + encodeURIComponent("" + getCatalog) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPurchaseOrderByPurchaseOrderId(_response);
        });
    }

    protected processGetPurchaseOrderByPurchaseOrderId(response: Response): Promise<PurchaseOrderDetails> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PurchaseOrderDetails;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PurchaseOrderDetails>(null as any);
    }

    getPurchaseOrdersByVendorOrderId(orderId: string | undefined, signal?: AbortSignal | undefined): Promise<PurchaseOrderDetails[]> {
        let url_ = this.baseUrl + "/api/Purchase/GetPurchaseOrdersByVendorOrderId?";
        if (orderId === null)
            throw new Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPurchaseOrdersByVendorOrderId(_response);
        });
    }

    protected processGetPurchaseOrdersByVendorOrderId(response: Response): Promise<PurchaseOrderDetails[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PurchaseOrderDetails[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PurchaseOrderDetails[]>(null as any);
    }

    getPurchaseOrders(query: PurchaseOrderQuery, useReadonlyDB: boolean | undefined, signal?: AbortSignal | undefined): Promise<EntitiesWithSummaryOfPurchaseOrder> {
        let url_ = this.baseUrl + "/api/Purchase/GetPurchaseOrders?";
        if (useReadonlyDB === null)
            throw new Error("The parameter 'useReadonlyDB' cannot be null.");
        else if (useReadonlyDB !== undefined)
            url_ += "useReadonlyDB=" + encodeURIComponent("" + useReadonlyDB) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPurchaseOrders(_response);
        });
    }

    protected processGetPurchaseOrders(response: Response): Promise<EntitiesWithSummaryOfPurchaseOrder> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EntitiesWithSummaryOfPurchaseOrder;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EntitiesWithSummaryOfPurchaseOrder>(null as any);
    }

    /**
     * This use the exact same backend as GetPurchaseOrders, but it is used by Advance Search
    The split up allows proper instrumentation and monitoring of the two different use cases
    This endpoint can later be replaced with a different backend
     * @param useReadonlyDB (optional) 
     */
    searchPurchaseOrders(query: PurchaseOrderQuery, useReadonlyDB: boolean | undefined, signal?: AbortSignal | undefined): Promise<EntitiesWithSummaryOfPurchaseOrder> {
        let url_ = this.baseUrl + "/api/Purchase/SearchPurchaseOrders?";
        if (useReadonlyDB === null)
            throw new Error("The parameter 'useReadonlyDB' cannot be null.");
        else if (useReadonlyDB !== undefined)
            url_ += "useReadonlyDB=" + encodeURIComponent("" + useReadonlyDB) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSearchPurchaseOrders(_response);
        });
    }

    protected processSearchPurchaseOrders(response: Response): Promise<EntitiesWithSummaryOfPurchaseOrder> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EntitiesWithSummaryOfPurchaseOrder;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EntitiesWithSummaryOfPurchaseOrder>(null as any);
    }

    /**
     * Advanced search V2 with OpenSearch backend to get paginated results
     */
    searchPurchaseOrdersV2(query: PurchaseOrderQueryV2, signal?: AbortSignal | undefined): Promise<EntitySearchResultOfEntitiesWithSummaryOfPurchaseOrderTicketGroup> {
        let url_ = this.baseUrl + "/api/Purchase/SearchPurchaseOrdersV2";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSearchPurchaseOrdersV2(_response);
        });
    }

    protected processSearchPurchaseOrdersV2(response: Response): Promise<EntitySearchResultOfEntitiesWithSummaryOfPurchaseOrderTicketGroup> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EntitySearchResultOfEntitiesWithSummaryOfPurchaseOrderTicketGroup;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EntitySearchResultOfEntitiesWithSummaryOfPurchaseOrderTicketGroup>(null as any);
    }

    /**
     * Advanced search V2 with OpenSearch backend to result summary
     */
    searchPurchaseOrdersV2Summary(query: PurchaseOrderQueryV2, signal?: AbortSignal | undefined): Promise<PurchaseOrderTicketGroup> {
        let url_ = this.baseUrl + "/api/Purchase/SearchPurchaseOrdersV2Summary";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSearchPurchaseOrdersV2Summary(_response);
        });
    }

    protected processSearchPurchaseOrdersV2Summary(response: Response): Promise<PurchaseOrderTicketGroup> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PurchaseOrderTicketGroup;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PurchaseOrderTicketGroup>(null as any);
    }

    getPurchaseOrdersWithTicketGroups(query: PurchaseOrderQuery, signal?: AbortSignal | undefined): Promise<EntitiesWithSummaryOfPurchaseOrderTicketGroup> {
        let url_ = this.baseUrl + "/api/Purchase/GetPurchaseOrdersWithTicketGroups";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPurchaseOrdersWithTicketGroups(_response);
        });
    }

    protected processGetPurchaseOrdersWithTicketGroups(response: Response): Promise<EntitiesWithSummaryOfPurchaseOrderTicketGroup> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EntitiesWithSummaryOfPurchaseOrderTicketGroup;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EntitiesWithSummaryOfPurchaseOrderTicketGroup>(null as any);
    }

    getTicketGroupsForEvents(query: PurchaseOrderQuery, signal?: AbortSignal | undefined): Promise<{ [key: string]: EntitiesWithSummaryOfPurchaseOrderTicketGroup; }> {
        let url_ = this.baseUrl + "/api/Purchase/GetTicketGroupsForEvents";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetTicketGroupsForEvents(_response);
        });
    }

    protected processGetTicketGroupsForEvents(response: Response): Promise<{ [key: string]: EntitiesWithSummaryOfPurchaseOrderTicketGroup; }> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as { [key: string]: EntitiesWithSummaryOfPurchaseOrderTicketGroup; };
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<{ [key: string]: EntitiesWithSummaryOfPurchaseOrderTicketGroup; }>(null as any);
    }

    getAccessibleVendors(getDeliveryOverride: boolean | undefined, getVendorAccountsCount: boolean | undefined, signal?: AbortSignal | undefined): Promise<PurchaseVendor[]> {
        let url_ = this.baseUrl + "/api/Purchase/GetAccessibleVendors?";
        if (getDeliveryOverride === null)
            throw new Error("The parameter 'getDeliveryOverride' cannot be null.");
        else if (getDeliveryOverride !== undefined)
            url_ += "getDeliveryOverride=" + encodeURIComponent("" + getDeliveryOverride) + "&";
        if (getVendorAccountsCount === null)
            throw new Error("The parameter 'getVendorAccountsCount' cannot be null.");
        else if (getVendorAccountsCount !== undefined)
            url_ += "getVendorAccountsCount=" + encodeURIComponent("" + getVendorAccountsCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAccessibleVendors(_response);
        });
    }

    protected processGetAccessibleVendors(response: Response): Promise<PurchaseVendor[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PurchaseVendor[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PurchaseVendor[]>(null as any);
    }

    getAccessibleAccessControlProviders(signal?: AbortSignal | undefined): Promise<AccessControlProvider[]> {
        let url_ = this.baseUrl + "/api/Purchase/GetAccessibleAccessControlProviders";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAccessibleAccessControlProviders(_response);
        });
    }

    protected processGetAccessibleAccessControlProviders(response: Response): Promise<AccessControlProvider[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AccessControlProvider[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AccessControlProvider[]>(null as any);
    }

    getAccessibleVendorAccounts(input: ValueTupleOfISetOfIntegerAndISetOfGuid, searchText: string | null | undefined, take: number | null | undefined, skip: number | null | undefined, signal?: AbortSignal | undefined): Promise<PurchaseVendorAccount[]> {
        let url_ = this.baseUrl + "/api/Purchase/GetAccessibleVendorAccounts?";
        if (searchText !== undefined && searchText !== null)
            url_ += "searchText=" + encodeURIComponent("" + searchText) + "&";
        if (take !== undefined && take !== null)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (skip !== undefined && skip !== null)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAccessibleVendorAccounts(_response);
        });
    }

    protected processGetAccessibleVendorAccounts(response: Response): Promise<PurchaseVendorAccount[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PurchaseVendorAccount[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PurchaseVendorAccount[]>(null as any);
    }

    getVendorAccountDetails(purchaseOrderVendorAccountId: string | undefined, signal?: AbortSignal | undefined): Promise<PurchaseVendorAccountDetails> {
        let url_ = this.baseUrl + "/api/Purchase/GetVendorAccountDetails?";
        if (purchaseOrderVendorAccountId === null)
            throw new Error("The parameter 'purchaseOrderVendorAccountId' cannot be null.");
        else if (purchaseOrderVendorAccountId !== undefined)
            url_ += "purchaseOrderVendorAccountId=" + encodeURIComponent("" + purchaseOrderVendorAccountId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetVendorAccountDetails(_response);
        });
    }

    protected processGetVendorAccountDetails(response: Response): Promise<PurchaseVendorAccountDetails> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PurchaseVendorAccountDetails;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PurchaseVendorAccountDetails>(null as any);
    }

    getPurchaseOrderIdsUsingOrderId(orderId: string | undefined, signal?: AbortSignal | undefined): Promise<number[]> {
        let url_ = this.baseUrl + "/api/Purchase/GetPurchaseOrderIdsUsingOrderId?";
        if (orderId === null)
            throw new Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPurchaseOrderIdsUsingOrderId(_response);
        });
    }

    protected processGetPurchaseOrderIdsUsingOrderId(response: Response): Promise<number[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number[]>(null as any);
    }

    getIsPurchasingIdsInUse(orderId: string | undefined, purchaseOrderVendorId: number | null | undefined, signal?: AbortSignal | undefined): Promise<PurchasingIdInUseResultType> {
        let url_ = this.baseUrl + "/api/Purchase/GetIsPurchasingIdsInUse?";
        if (orderId === null)
            throw new Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
        if (purchaseOrderVendorId !== undefined && purchaseOrderVendorId !== null)
            url_ += "purchaseOrderVendorId=" + encodeURIComponent("" + purchaseOrderVendorId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetIsPurchasingIdsInUse(_response);
        });
    }

    protected processGetIsPurchasingIdsInUse(response: Response): Promise<PurchasingIdInUseResultType> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PurchasingIdInUseResultType;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PurchasingIdInUseResultType>(null as any);
    }

    getMonthsContainerPurchaseOrders(query: PurchaseOrderQuery, signal?: AbortSignal | undefined): Promise<MonthContainingPurchaseOrdersResult[]> {
        let url_ = this.baseUrl + "/api/Purchase/GetMonthsContainerPurchaseOrders";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetMonthsContainerPurchaseOrders(_response);
        });
    }

    protected processGetMonthsContainerPurchaseOrders(response: Response): Promise<MonthContainingPurchaseOrdersResult[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MonthContainingPurchaseOrdersResult[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MonthContainingPurchaseOrdersResult[]>(null as any);
    }

    getTimePeriodContainerPurchaseOrders(query: PurchaseOrderQuery, timePeriodType: TimePeriodType | undefined, signal?: AbortSignal | undefined): Promise<TimePeriodContainingPurchaseOrderResult[]> {
        let url_ = this.baseUrl + "/api/Purchase/GetTimePeriodContainerPurchaseOrders?";
        if (timePeriodType === null)
            throw new Error("The parameter 'timePeriodType' cannot be null.");
        else if (timePeriodType !== undefined)
            url_ += "timePeriodType=" + encodeURIComponent("" + timePeriodType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetTimePeriodContainerPurchaseOrders(_response);
        });
    }

    protected processGetTimePeriodContainerPurchaseOrders(response: Response): Promise<TimePeriodContainingPurchaseOrderResult[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TimePeriodContainingPurchaseOrderResult[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TimePeriodContainingPurchaseOrderResult[]>(null as any);
    }

    insertPurchaseOrder(input: PurchaseOrderDetailsInput, isManual: boolean | undefined, signal?: AbortSignal | undefined): Promise<PosUiActionResult> {
        let url_ = this.baseUrl + "/api/Purchase/InsertPurchaseOrder?";
        if (isManual === null)
            throw new Error("The parameter 'isManual' cannot be null.");
        else if (isManual !== undefined)
            url_ += "isManual=" + encodeURIComponent("" + isManual) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processInsertPurchaseOrder(_response);
        });
    }

    protected processInsertPurchaseOrder(response: Response): Promise<PosUiActionResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PosUiActionResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PosUiActionResult>(null as any);
    }

    addTicketGroupsToPurchaseOrder(input: PurchaseOrderDetailsInput, isManual: boolean | undefined, signal?: AbortSignal | undefined): Promise<PosUiActionResult> {
        let url_ = this.baseUrl + "/api/Purchase/AddTicketGroupsToPurchaseOrder?";
        if (isManual === null)
            throw new Error("The parameter 'isManual' cannot be null.");
        else if (isManual !== undefined)
            url_ += "isManual=" + encodeURIComponent("" + isManual) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAddTicketGroupsToPurchaseOrder(_response);
        });
    }

    protected processAddTicketGroupsToPurchaseOrder(response: Response): Promise<PosUiActionResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PosUiActionResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PosUiActionResult>(null as any);
    }

    insertPurchaseOrders(input: PurchaseOrderDetailsInput[], isManual: boolean | undefined, signal?: AbortSignal | undefined): Promise<PosUiActionResultWithDataOfIEnumerableOfNullableLong> {
        let url_ = this.baseUrl + "/api/Purchase/InsertPurchaseOrders?";
        if (isManual === null)
            throw new Error("The parameter 'isManual' cannot be null.");
        else if (isManual !== undefined)
            url_ += "isManual=" + encodeURIComponent("" + isManual) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processInsertPurchaseOrders(_response);
        });
    }

    protected processInsertPurchaseOrders(response: Response): Promise<PosUiActionResultWithDataOfIEnumerableOfNullableLong> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PosUiActionResultWithDataOfIEnumerableOfNullableLong;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PosUiActionResultWithDataOfIEnumerableOfNullableLong>(null as any);
    }

    downloadPurchaseFileTemplate(includeEventIdFields: boolean | undefined, signal?: AbortSignal | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Purchase/DownloadPurchaseFileTemplate?";
        if (includeEventIdFields === null)
            throw new Error("The parameter 'includeEventIdFields' cannot be null.");
        else if (includeEventIdFields !== undefined)
            url_ += "includeEventIdFields=" + encodeURIComponent("" + includeEventIdFields) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDownloadPurchaseFileTemplate(_response);
        });
    }

    protected processDownloadPurchaseFileTemplate(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @param purchaseOrderId Used for route parsing so that action argument is parsed for consignee impersonation
     */
    updatePurchaseOrderByPurchaseOrderId(purchaseOrderId: number, input: PurchaseOrderDetailsInput, signal?: AbortSignal | undefined): Promise<PosUiActionResult> {
        let url_ = this.baseUrl + "/api/Purchase/{purchaseOrderId}";
        if (purchaseOrderId === undefined || purchaseOrderId === null)
            throw new Error("The parameter 'purchaseOrderId' must be defined.");
        url_ = url_.replace("{purchaseOrderId}", encodeURIComponent("" + purchaseOrderId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdatePurchaseOrderByPurchaseOrderId(_response);
        });
    }

    protected processUpdatePurchaseOrderByPurchaseOrderId(response: Response): Promise<PosUiActionResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PosUiActionResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PosUiActionResult>(null as any);
    }

    updatePurchasesQualityControlState(inputs: ValueTupleOfISetOfLongAndPosFieldOfNullableQualityControlState, signal?: AbortSignal | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Purchase/UpdatePurchasesQualityControlState";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(inputs);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdatePurchasesQualityControlState(_response);
        });
    }

    protected processUpdatePurchasesQualityControlState(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    updatePurchaseOrderConversionRate(inputs: ValueTupleOfLongAndDecimal, signal?: AbortSignal | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Purchase/UpdatePurchaseOrderConversionRate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(inputs);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdatePurchaseOrderConversionRate(_response);
        });
    }

    protected processUpdatePurchaseOrderConversionRate(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    getVendor(vendorId: number | undefined, signal?: AbortSignal | undefined): Promise<PurchaseVendor> {
        let url_ = this.baseUrl + "/api/Purchase/GetVendor?";
        if (vendorId === null)
            throw new Error("The parameter 'vendorId' cannot be null.");
        else if (vendorId !== undefined)
            url_ += "vendorId=" + encodeURIComponent("" + vendorId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetVendor(_response);
        });
    }

    protected processGetVendor(response: Response): Promise<PurchaseVendor> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PurchaseVendor;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PurchaseVendor>(null as any);
    }

    mergeVendor(vendor: PurchaseVendor, signal?: AbortSignal | undefined): Promise<number | null> {
        let url_ = this.baseUrl + "/api/Purchase/MergeVendor";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(vendor);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processMergeVendor(_response);
        });
    }

    protected processMergeVendor(response: Response): Promise<number | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number | null>(null as any);
    }

    deleteVendor(vendorId: number | undefined, signal?: AbortSignal | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Purchase/DeleteVendor?";
        if (vendorId === null)
            throw new Error("The parameter 'vendorId' cannot be null.");
        else if (vendorId !== undefined)
            url_ += "vendorId=" + encodeURIComponent("" + vendorId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteVendor(_response);
        });
    }

    protected processDeleteVendor(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    mergeVendorAccount(vendorAccount: PurchaseVendorAccountDetails, signal?: AbortSignal | undefined): Promise<string | null> {
        let url_ = this.baseUrl + "/api/Purchase/MergeVendorAccount";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(vendorAccount);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processMergeVendorAccount(_response);
        });
    }

    protected processMergeVendorAccount(response: Response): Promise<string | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string | null>(null as any);
    }

    deleteVendorAccount(vendorAccountId: string | undefined, signal?: AbortSignal | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Purchase/DeleteVendorAccount?";
        if (vendorAccountId === null)
            throw new Error("The parameter 'vendorAccountId' cannot be null.");
        else if (vendorAccountId !== undefined)
            url_ += "vendorAccountId=" + encodeURIComponent("" + vendorAccountId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteVendorAccount(_response);
        });
    }

    protected processDeleteVendorAccount(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    getAllCurrencyConversionOverride(signal?: AbortSignal | undefined): Promise<CurrencyConversionOverride[]> {
        let url_ = this.baseUrl + "/api/Purchase/GetAllCurrencyConversionOverride";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllCurrencyConversionOverride(_response);
        });
    }

    protected processGetAllCurrencyConversionOverride(response: Response): Promise<CurrencyConversionOverride[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CurrencyConversionOverride[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CurrencyConversionOverride[]>(null as any);
    }

    insertCurrencyConversionOverride(conversionOverrideRequest: CurrencyConversionOverrideRequest, signal?: AbortSignal | undefined): Promise<number | null> {
        let url_ = this.baseUrl + "/api/Purchase/InsertCurrencyConversionOverride";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(conversionOverrideRequest);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processInsertCurrencyConversionOverride(_response);
        });
    }

    protected processInsertCurrencyConversionOverride(response: Response): Promise<number | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number | null>(null as any);
    }

    updateCurrencyConversionOverride(conversionOverrideRequest: CurrencyConversionOverrideRequest, signal?: AbortSignal | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Purchase/UpdateCurrencyConversionOverride";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(conversionOverrideRequest);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateCurrencyConversionOverride(_response);
        });
    }

    protected processUpdateCurrencyConversionOverride(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    deleteCurrencyConversionOverride(currencyConversionOverrideId: number | undefined, signal?: AbortSignal | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Purchase/DeleteCurrencyConversionOverride?";
        if (currencyConversionOverrideId === null)
            throw new Error("The parameter 'currencyConversionOverrideId' cannot be null.");
        else if (currencyConversionOverrideId !== undefined)
            url_ += "currencyConversionOverrideId=" + encodeURIComponent("" + currencyConversionOverrideId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteCurrencyConversionOverride(_response);
        });
    }

    protected processDeleteCurrencyConversionOverride(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    getAccessiblePurchasePaymentMethods(signal?: AbortSignal | undefined): Promise<PurchasePaymentMethod[]> {
        let url_ = this.baseUrl + "/api/Purchase/GetAccessiblePurchasePaymentMethods";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAccessiblePurchasePaymentMethods(_response);
        });
    }

    protected processGetAccessiblePurchasePaymentMethods(response: Response): Promise<PurchasePaymentMethod[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PurchasePaymentMethod[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PurchasePaymentMethod[]>(null as any);
    }

    getPurchasePaymentMethodsByName(paymentMethodName: string | undefined, signal?: AbortSignal | undefined): Promise<PurchasePaymentMethod[]> {
        let url_ = this.baseUrl + "/api/Purchase/GetPurchasePaymentMethodsByName?";
        if (paymentMethodName === null)
            throw new Error("The parameter 'paymentMethodName' cannot be null.");
        else if (paymentMethodName !== undefined)
            url_ += "paymentMethodName=" + encodeURIComponent("" + paymentMethodName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPurchasePaymentMethodsByName(_response);
        });
    }

    protected processGetPurchasePaymentMethodsByName(response: Response): Promise<PurchasePaymentMethod[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PurchasePaymentMethod[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PurchasePaymentMethod[]>(null as any);
    }

    insertPurchasePaymentMethod(input: PurchasePaymentMethod, signal?: AbortSignal | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/Purchase/InsertPurchasePaymentMethod";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processInsertPurchasePaymentMethod(_response);
        });
    }

    protected processInsertPurchasePaymentMethod(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    updatePurchasePaymentMethod(input: PurchasePaymentMethod, signal?: AbortSignal | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Purchase/UpdatePurchasePaymentMethod";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdatePurchasePaymentMethod(_response);
        });
    }

    protected processUpdatePurchasePaymentMethod(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    deletePurchasePaymentMethod(purchasePaymentMethodId: number, signal?: AbortSignal | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Purchase/DeletePurchasePaymentMethod";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(purchasePaymentMethodId);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeletePurchasePaymentMethod(_response);
        });
    }

    protected processDeletePurchasePaymentMethod(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    cancelPurchaseOrder(purchaseOrderId: number | undefined, rejectSale: boolean | null | undefined, saleCancellationReason: SaleCancellationReason | null | undefined, signal?: AbortSignal | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Purchase/CancelPurchaseOrder?";
        if (purchaseOrderId === null)
            throw new Error("The parameter 'purchaseOrderId' cannot be null.");
        else if (purchaseOrderId !== undefined)
            url_ += "purchaseOrderId=" + encodeURIComponent("" + purchaseOrderId) + "&";
        if (rejectSale !== undefined && rejectSale !== null)
            url_ += "rejectSale=" + encodeURIComponent("" + rejectSale) + "&";
        if (saleCancellationReason !== undefined && saleCancellationReason !== null)
            url_ += "saleCancellationReason=" + encodeURIComponent("" + saleCancellationReason) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCancelPurchaseOrder(_response);
        });
    }

    protected processCancelPurchaseOrder(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    voidPurchaseOrder(purchaseOrderId: number | undefined, signal?: AbortSignal | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Purchase/VoidPurchaseOrder?";
        if (purchaseOrderId === null)
            throw new Error("The parameter 'purchaseOrderId' cannot be null.");
        else if (purchaseOrderId !== undefined)
            url_ += "purchaseOrderId=" + encodeURIComponent("" + purchaseOrderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processVoidPurchaseOrder(_response);
        });
    }

    protected processVoidPurchaseOrder(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    restorePurchaseOrder(purchaseOrderId: number | undefined, signal?: AbortSignal | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Purchase/RestorePurchaseOrder?";
        if (purchaseOrderId === null)
            throw new Error("The parameter 'purchaseOrderId' cannot be null.");
        else if (purchaseOrderId !== undefined)
            url_ += "purchaseOrderId=" + encodeURIComponent("" + purchaseOrderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRestorePurchaseOrder(_response);
        });
    }

    protected processRestorePurchaseOrder(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    getDeliveryOverrideForNewTicketGroup(input: ValueTupleOfNullableIntegerAndNullableIntegerAndNullableGuidAndBoolean, signal?: AbortSignal | undefined): Promise<DeliveryOverride | null> {
        let url_ = this.baseUrl + "/api/Purchase/GetDeliveryOverrideForNewTicketGroup";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetDeliveryOverrideForNewTicketGroup(_response);
        });
    }

    protected processGetDeliveryOverrideForNewTicketGroup(response: Response): Promise<DeliveryOverride | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DeliveryOverride;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DeliveryOverride | null>(null as any);
    }

    mergePurchaseEventOverrides(purchaseEventOverrides: PurchaseEventOverride[], viagogoEventId: number | undefined, signal?: AbortSignal | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Purchase?";
        if (viagogoEventId === null)
            throw new Error("The parameter 'viagogoEventId' cannot be null.");
        else if (viagogoEventId !== undefined)
            url_ += "viagogoEventId=" + encodeURIComponent("" + viagogoEventId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(purchaseEventOverrides);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processMergePurchaseEventOverrides(_response);
        });
    }

    protected processMergePurchaseEventOverrides(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    getPurchaseEventOverrides(viagogoEventId: number | undefined, signal?: AbortSignal | undefined): Promise<PurchaseEventOverride[]> {
        let url_ = this.baseUrl + "/api/Purchase/GetPurchaseEventOverrides?";
        if (viagogoEventId === null)
            throw new Error("The parameter 'viagogoEventId' cannot be null.");
        else if (viagogoEventId !== undefined)
            url_ += "viagogoEventId=" + encodeURIComponent("" + viagogoEventId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPurchaseEventOverrides(_response);
        });
    }

    protected processGetPurchaseEventOverrides(response: Response): Promise<PurchaseEventOverride[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PurchaseEventOverride[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PurchaseEventOverride[]>(null as any);
    }

    exportPurchases(request: PurchaseOrderExportRequest, selectedTicketGroupsOnly: boolean | undefined, signal?: AbortSignal | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Purchase/ExportPurchases?";
        if (selectedTicketGroupsOnly === null)
            throw new Error("The parameter 'selectedTicketGroupsOnly' cannot be null.");
        else if (selectedTicketGroupsOnly !== undefined)
            url_ += "selectedTicketGroupsOnly=" + encodeURIComponent("" + selectedTicketGroupsOnly) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processExportPurchases(_response);
        });
    }

    protected processExportPurchases(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    downloadMergedUserDocumentsPdf(ticketGroupId: number | undefined, signal?: AbortSignal | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Purchase/DownloadMergedUserDocumentsPdf?";
        if (ticketGroupId === null)
            throw new Error("The parameter 'ticketGroupId' cannot be null.");
        else if (ticketGroupId !== undefined)
            url_ += "ticketGroupId=" + encodeURIComponent("" + ticketGroupId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            signal,
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDownloadMergedUserDocumentsPdf(_response);
        });
    }

    protected processDownloadMergedUserDocumentsPdf(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}
export interface IPurchaseOrdersAggregationOpenSearchClient {

    /**
     * Gets aggregated purchase order summary with currency conversion
     * @param request Aggregation request containing filters and options
     * @return Aggregated purchase order summary in target currency
     */
    summary(request: MultiCurrencyAggregationRequestOfPurchaseOrderSearchRequestV2AndPurchaseOrderFilterQueryV2): Promise<PurchaseOrderAggregationResponse>;

    /**
     * Gets aggregated purchase order summary by original currency (for debugging/analysis)
     * @param request Aggregation request containing filters and options
     * @return Raw aggregation results by currency
     */
    byCurrency(request: MultiCurrencyAggregationRequestOfPurchaseOrderSearchRequestV2AndPurchaseOrderFilterQueryV2): Promise<{ [key: string]: PurchaseOrderAggregationSummary; }>;

    /**
     * Gets purchase orders with aggregated summary for UI display
    Combines individual purchase order data with computed aggregated totals
     * @param request Search request with filters and aggregation options
     * @return Purchase orders with aggregated summary
     */
    uIList(request: MultiCurrencyAggregationRequestOfPurchaseOrderSearchRequestV2AndPurchaseOrderFilterQueryV2): Promise<EntitiesWithSummaryOfPurchaseOrderTicketGroup>;
}

export class PurchaseOrdersAggregationOpenSearchClient extends PosClientBase implements IPurchaseOrdersAggregationOpenSearchClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: PosClientConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Gets aggregated purchase order summary with currency conversion
     * @param request Aggregation request containing filters and options
     * @return Aggregated purchase order summary in target currency
     */
    summary(request: MultiCurrencyAggregationRequestOfPurchaseOrderSearchRequestV2AndPurchaseOrderFilterQueryV2, signal?: AbortSignal | undefined): Promise<PurchaseOrderAggregationResponse> {
        let url_ = this.baseUrl + "/api/OpenSearch/PurchaseOrdersAggregation/Summary";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSummary(_response);
        });
    }

    protected processSummary(response: Response): Promise<PurchaseOrderAggregationResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PurchaseOrderAggregationResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PurchaseOrderAggregationResponse>(null as any);
    }

    /**
     * Gets aggregated purchase order summary by original currency (for debugging/analysis)
     * @param request Aggregation request containing filters and options
     * @return Raw aggregation results by currency
     */
    byCurrency(request: MultiCurrencyAggregationRequestOfPurchaseOrderSearchRequestV2AndPurchaseOrderFilterQueryV2, signal?: AbortSignal | undefined): Promise<{ [key: string]: PurchaseOrderAggregationSummary; }> {
        let url_ = this.baseUrl + "/api/OpenSearch/PurchaseOrdersAggregation/ByCurrency";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processByCurrency(_response);
        });
    }

    protected processByCurrency(response: Response): Promise<{ [key: string]: PurchaseOrderAggregationSummary; }> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as { [key: string]: PurchaseOrderAggregationSummary; };
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<{ [key: string]: PurchaseOrderAggregationSummary; }>(null as any);
    }

    /**
     * Gets purchase orders with aggregated summary for UI display
    Combines individual purchase order data with computed aggregated totals
     * @param request Search request with filters and aggregation options
     * @return Purchase orders with aggregated summary
     */
    uIList(request: MultiCurrencyAggregationRequestOfPurchaseOrderSearchRequestV2AndPurchaseOrderFilterQueryV2, signal?: AbortSignal | undefined): Promise<EntitiesWithSummaryOfPurchaseOrderTicketGroup> {
        let url_ = this.baseUrl + "/api/OpenSearch/PurchaseOrdersAggregation/UIList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUIList(_response);
        });
    }

    protected processUIList(response: Response): Promise<EntitiesWithSummaryOfPurchaseOrderTicketGroup> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EntitiesWithSummaryOfPurchaseOrderTicketGroup;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EntitiesWithSummaryOfPurchaseOrderTicketGroup>(null as any);
    }
}
export interface IPurchaseOrdersOpenSearchClient {

    /**
     * Enhanced purchase order search with ComprehensivePurchaseOrderDocument mapped to UI DTOs
    Uses ComprehensivePurchaseOrderDocument for comprehensive filtering then maps to PurchaseOrder DTOs for UI consumption
    This provides the best of both worlds: comprehensive filtering + familiar UI DTOs
     * @param request The enhanced search request with PurchaseOrderFilterQueryV2 criteria and options
     * @return Search results mapped to PurchaseOrder DTOs with comprehensive search capabilities
     */
    searchPurchaseOrdersV3(request: PurchaseOrderSearchRequestV2): Promise<SecurePurchaseOrdersSearchMappedResult>;
}

export class PurchaseOrdersOpenSearchClient extends PosClientBase implements IPurchaseOrdersOpenSearchClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: PosClientConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Enhanced purchase order search with ComprehensivePurchaseOrderDocument mapped to UI DTOs
    Uses ComprehensivePurchaseOrderDocument for comprehensive filtering then maps to PurchaseOrder DTOs for UI consumption
    This provides the best of both worlds: comprehensive filtering + familiar UI DTOs
     * @param request The enhanced search request with PurchaseOrderFilterQueryV2 criteria and options
     * @return Search results mapped to PurchaseOrder DTOs with comprehensive search capabilities
     */
    searchPurchaseOrdersV3(request: PurchaseOrderSearchRequestV2, signal?: AbortSignal | undefined): Promise<SecurePurchaseOrdersSearchMappedResult> {
        let url_ = this.baseUrl + "/api/OpenSearch/SearchPurchaseOrdersV3";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSearchPurchaseOrdersV3(_response);
        });
    }

    protected processSearchPurchaseOrdersV3(response: Response): Promise<SecurePurchaseOrdersSearchMappedResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SecurePurchaseOrdersSearchMappedResult;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SecurePurchaseOrdersSearchMappedResult>(null as any);
    }
}
